export const handleLiveSearchNode = (
	macroNode: any,
): {
	labels: any;
	placeholder: any;
	size: any;
	spaceKey: any;
	type: any;
	additional: any;
	macroId: any;
} => {
	const macroParams = macroNode?.attrs?.parameters?.macroParams;

	return {
		labels: macroParams?.labels?.value,
		placeholder: macroParams?.placeholder?.value,
		size: macroParams?.size?.value,
		spaceKey: macroParams?.spaceKey?.value,
		type: macroParams?.type?.value,
		additional: macroParams?.additional?.value,
		macroId: macroNode?.attrs?.parameters?.macroMetadata?.macroId?.value,
	};
};
